export default __webpack_public_path__ + "static/media/Store.9fd91219.png";